import { markRaw } from 'vue'
import PopupAbstract from './PopupAbstract'
import PopupDateTime from './PopupDateTime.vue'

export default class PopupDateTimeService extends PopupAbstract {
  public name = 'PopupDateTimeService'
  protected component = markRaw(PopupDateTime)
}
